<template>
  <a-layout-content class="my-4 mx-3">
    <div class="container">
      <invoices-view :acl="baseAcl" :allow-filtering="true" />
    </div>
  </a-layout-content>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { BaseAclInterface } from "@/modules/authentication/types";
import { useAuthenticationStore } from "@/modules/authentication/_store";
import InvoicesView from "../_components/InvoicesView.vue";

// Pinia
const authenticationStore = useAuthenticationStore();
const baseAcl = computed<BaseAclInterface>(() => authenticationStore.baseAcl);
</script>
